module.exports = __webpack_public_path__ + "img/6企业实力bg.911d9d8c.png";